import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function TextStringIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <Box
        as="path"
        fill="currentColor"
        d="M8.354 19c-.1 0-.182-.06-.249-.178a.732.732 0 0 1-.09-.325c0-.112.024-.198.07-.257.047-.059.133-.095.26-.108.603-.033 1.093-.112 1.471-.237.385-.132.577-.362.577-.69V5.976H7.906c-.345 0-.63.2-.855.602A4.83 4.83 0 0 0 6.563 7.9c-.1.486-.162.9-.189 1.243-.013.112-.08.194-.199.246a.86.86 0 0 1-.368.08c-.1 0-.209-.03-.328-.09-.12-.065-.179-.147-.179-.246.033-.987.073-1.92.12-2.802C5.471 5.444 5.531 5 5.597 5H18.4c.067 0 .123.444.17 1.332.053.881.096 1.815.129 2.802 0 .099-.06.18-.18.247a.748.748 0 0 1-.328.088.926.926 0 0 1-.377-.079.301.301 0 0 1-.19-.246 10.744 10.744 0 0 0-.457-2.112c-.226-.703-.584-1.055-1.075-1.055h-2.357v11.198c0 .263.103.46.308.592.206.131.441.22.707.266.265.04.597.073.994.099.146.013.242.043.289.089.046.039.07.131.07.276a.678.678 0 0 1-.1.325c-.06.119-.14.178-.239.178h-7.41Z"
      />
    </Icon>
  );
}
